import { overviewProjectsTableTotalWidths } from './OverviewProjectsTable.types'

export const getOverviewProjectsTableFlexWidth = (columnsCount: number) => {
  return `calc((100% - ${overviewProjectsTableTotalWidths.fixedCols
    }px) / ${columnsCount})`
}
